import { Subscription } from 'rxjs';
import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ColorSchemes } from 'src/styles/color-scheme.type';
import { TabNavigationLink } from '../../interfaces/tab-navigation-link.interface';

@Component({
  selector: 'app-tab-navigation',
  templateUrl: './tab-navigation.component.html',
  styleUrls: ['./tab-navigation.component.scss']
})
export class TabNavigationComponent implements OnInit, OnDestroy, OnChanges {
  @Input() links: TabNavigationLink[] = [];
  @Input() defaultSelected?: TabNavigationLink;
  @Input() colors: ColorSchemes = ColorSchemes.PRIMARY;

  @Input() defaultPath?: string;

  // no routerLink
  @Input() routerOff: boolean = false;
  @Output() clicked = new EventEmitter<TabNavigationLink>();

  @ContentChild(TemplateRef) child!: TemplateRef<any>;

  public activeLink!: TabNavigationLink;

  private subscription$: Subscription = new Subscription();

  ColorSchemes = ColorSchemes;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.handleAutomaticLink();

    this.subscription$.add(this.route.url.subscribe(() => this.handleAutomaticLink()));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.links) {
      this.links = changes.links.currentValue;
      this.onLinkClicked(this.defaultSelected ?? this.links[0]);
    }
    if (changes.defaultSelected) {
      this.activeLink = changes.defaultSelected.currentValue;
    }

    if (changes.defaultPath) {
      const link = this.links.find((x) => x.path == changes.defaultPath.currentValue) ?? this.links[0];
      this.onLinkClicked(link);
    }
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  private clearUrl(url: string): string {
    let preparedUrl = url;
    const params = this.route.snapshot.params;
    Object.keys(params).forEach((key) => {
      preparedUrl = preparedUrl.replace('/' + params[key], '');
    });
    return preparedUrl;
  }

  private handleAutomaticLink(): void {
    const url = this.clearUrl(this.router.url);
    const initialLink = this.links.find((link) => url === link.path);
    if (initialLink) {
      this.onLinkClicked(initialLink);
    }
  }

  public onLinkClicked(link: TabNavigationLink): void {
    this.activeLink = link;
    this.clicked.emit(link);
  }

  public isActive(link: TabNavigationLink): boolean {
    return this.activeLink == link;
  }
}
